$(window).load(function() {
  var h = window.innerHeight;
  var w = window.innerWidth;

  if ($(window).width() < 1180) {
    $('nav#menu')
      .addClass('close')
      .css({ transition: '.4s;' });
  }
});

$(document).ready(function() {
  $(window).resize(function() {
    if ($(window).width() > 1180) {
      $('nav#menu').removeClass('close');
    } else {
      $('nav#menu').addClass('close');
    }
  });
});

$(function() {
  var pLeft = ($('div#wrap').width() - 964) / 2;
  if ($(window).width() > 1180) {
    $('div.sticky_title p').css({ 'margin-left': '230px' });
  } else {
    $('div.sticky_title p').css({ 'margin-left': pLeft });
  }

  $(window).scroll(function() {
    var ScrTop = $(window).scrollTop();
    var footerPos = $('footer').offset().top - 721 - 64;

    if (ScrTop > 500) {
      $('#goTopBtn').fadeIn('fast');
    } else {
      $('#goTopBtn').fadeOut('slow');
    }

    if (ScrTop > 50) {
      $('div.sticky_title').fadeIn('fast');
    } else {
      $('div.sticky_title').fadeOut('slow');
    }

    if (ScrTop > footerPos) {
      $('nav#menu').addClass('bottom');
    } else {
      $('nav#menu').removeClass('bottom');
    }
  });

  $('a[href^=#]').click(function() {
    var speed = 400;
    var href = $(this).attr('href');
    if (href == '#' || href == '') {
      return true;
    }

    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 140;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  $('header #nav-icon').click(function() {
    $('nav#menu').toggleClass('close');
    $('nav#menu').toggleClass('border');
  });
  $('#menu .category,#menu .sub_nav').hover(
    function() {
      $('#menu .sub_nav').css({ display: 'block' });
    },
    function() {
      $('#menu .sub_nav').css({ display: 'none' });
    }
  );

  //  $('header ul.headerList li.account').click(function(){
  //    $("div.modal").click(function(){
  //      event.stopPropagation();
  //    });
  //    $('div#login').toggleClass('open');
  //    $("div#login").click(function(){
  //      $('div#login').removeClass('open');
  //    });
  //  });

  $('header ul.headerList li.account').click(function() {
    $('div#login').addClass('open');
    $('div#login p.close ').click(function() {
      $('div#login')
        .unbind()
        .removeClass('open');
    });
    $(document).on('click', '.modal', function(event) {
      event.stopPropagation();
    });
  });

  //    $(document).on('click', 'header ul.headerList li.account', function (event) {
  //        $('div#login').toggleClass('open');
  //        if ( $(this).closest(".modal").length === 0 ){
  //            $("div#login").click(function(){
  //                $('div#login').removeClass('open');
  //            });
  //        } else {
  //            event.preventDefault();
  //            event.stopPropagation();
  //        }
  //    });

  $('form div div.passBtn').click(function() {
    $('div#changePass').toggleClass('open');
    $('div#changePass').click(function() {
      $('div#changePass').removeClass('open');
    });
    $('div.modal').click(function() {
      event.stopPropagation();
    });
  });

  $('.profMore').click(function() {
    $($(this).prev('p.profTxt')).toggleClass('hide');
    if ($(this).hasClass('moreClose')) {
      $(this).text('続きを読む');
    } else {
      $(this).text('閉じる');
    }
    $(this).toggleClass('moreClose');
  });

  // コメントレポート
  $(function() {
    $('div.report').click(function() {
      var modalon = $('div.reportTxt', this);
      if ($(modalon).css('display') == 'none') {
        $('div.reportTxt').hide();
        $(modalon).show();
      } else {
        $('div.reportTxt').hide();
      }
    });
    $(document).on('click', function(e) {
      if ($(e.target).closest('.report').length === 0) {
        $('div.reportTxt').hide();
      }
    });
  });
});
